import React, { useState } from "react";
import { useHistory } from "react-router";
import { ChromePicker } from "react-color";
import { useRouteMatch } from "react-router-dom";

import Back from "../widgets/Back";
import Colors from "../../helpers/Colors";
import { defaultColors, other } from "../../constants/defaults";

const BlockedTimeSlotOther = () => {
  const history = useHistory();
  const match = useRouteMatch();

  const [background, setBackground] = useState(defaultColors.Green.color);

  const activeType = Colors.getBTStypeColor(match.params.colorCode);

  const handleChangeComplete = (color) => {
    setBackground(color.hex);
  };

  const save = () => {
    let item = JSON.parse(JSON.stringify(other));
    item.color = background;

    Colors.selectBTStypeColor(match.params.colorCode, item);
    history.goBack();
  };

  return (
    <div className="settings-body">
      <div className="title">
        <Back />
        <button onClick={save} className="btn btn-link btn-color-right" type="button">
          Save
        </button>
        <div className="name">{activeType.name}</div>
      </div>
      <div className="body">
        <ChromePicker color={background} onChangeComplete={handleChangeComplete} />
      </div>
    </div>
  );
};

export default BlockedTimeSlotOther;
